import React, { useEffect, useState } from 'react'
import { Box, Button, IconButton, Pagination, Stack, TextField, Typography, useTheme } from '@mui/material';
import route from '../../utils/Routes';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ScrollBox from '../../components/ScrollBox';
import CountCard from '../../components/CountCard';
import ProductCard from '../../components/ProductCard';
import raisedSVG from '../../assets/svg/raisedrequestIcon.svg';
import approvedSVG from '../../assets/svg/approvedrequestIcon.svg';
import cartSVG from '../../assets/svg/cartSvg.svg';
import { useQuery, useQueryClient } from 'react-query';
import QueryKey from '../../utils/QueryKey';
import { useAuthContext } from '../../context/AuthContext';
import { customAlert } from '../../components/notify';
import { getComDashServ } from '../../services/amtc-service';
import SearchTxtField from '../../components/SearchTxtField';
import { isNotEmpty, NumberFormatter } from '../../utils/format';
import constants from '../../utils/Constants';
import CtrlCustomDropDown from '../../components/CtrlCustomDropDown';
import { MdEditSquare } from "react-icons/md";
import EditProjAmtLmit from './EditProjAmtLmit';


function Dashboard() {
    const theme = useTheme();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { setLoadingScreen, ctxtUser, currProjArr } = useAuthContext();
    const limit = 12;
    const [searchParams, setSearchParams] = useSearchParams();
    const pgNo = parseInt(searchParams.get("pgNo") || "1");
    const querySearchWord = searchParams.get("s") || "";
    const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0)
    const currProj = JSON.parse(localStorage.getItem('currProj') || "{}");
    const [selProjId, setSelProjId] = useState(currProj?.projIdStrg ?? "");
    const { isLoading: isDasLoading, isError: isDasErr, error: dasErr, data: dashData } = useQuery([QueryKey.comDashboard, pgNo,
        isSrchBtnClick, ctxtUser.userId, selProjId],
        () => getComDashServ({ userType: ctxtUser.userType, limit, pageNumber: pgNo, searchKeyWord: searchWord, projIdStrg: selProjId }), {
        enabled: getDataCheck(selProjId, ctxtUser),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    const [amtMdl, setAmtMdl] = useState(false);
    const handleAmtMdlClose = () => setAmtMdl(false);
    const handleAmtMdlOpen = () => setAmtMdl(true);
    const handleAmtSaveMdlClose = () => {
        queryClient.invalidateQueries()
        setAmtMdl(false);
        navigate("/");
    }

    function getDataCheck(selProjId, ctxtUser) {
        if (ctxtUser.userType === constants.focalPoint || ctxtUser.userType === constants.lineManager) {
            // if (isNotEmpty(selProjId))
            //     return true
            // return false;
        }
        return true
    }

    useEffect(() => {
        if (isDasLoading) {
            setLoadingScreen(true);
        } else {
            setLoadingScreen(false);
        }
    }, [isDasLoading, setLoadingScreen]);


    useEffect(() => {
        if (currProjArr.length > 0) {
            const stProj = JSON.parse(localStorage.getItem('currProj') || "{}");
            setSelProjId(stProj?.projIdStrg ?? "");
        }
    }, [currProjArr]);


    const handleViewCatClick = () => {
        if (ctxtUser?.isComUser === true)
            navigate(route.comCataLog);
        else {
            navigate(route.aCataLog);
        }
    };

    async function onSearchBtnClick(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            return prev
        }, { replace: true })
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
        setSearchParams(prev => {
            prev.set("s", encodeURIComponent(e.target.value))
            return prev
        }, { replace: true })
    }


    // function handleDDChange(e) {
    //     setSearchParams(prev => {
    //         prev.set("st", e.target.value)
    //         return prev
    //     }, { replace: true })
    // }

    function handleProjChange(e) {
        setSelProjId(e.target.value);
        const selObj = currProjArr.find((i) => i.projIdStrg === e.target.value)
        localStorage.setItem('currProj', selObj ? JSON.stringify(selObj) : null);
        navigate(0)
    }

    const handlePageChange = async (event, value) => {
        setSearchParams(prev => {
            prev.set("pgNo", value)
            return prev
        }, { replace: true })
    };

    function handleOnClear(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchWord("");
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            prev.set("s", "")
            return prev
        }, { replace: true })
    }

    function handlePrClick() {
        navigate(route.cProdreqlist)
    }

    function handlePoClick() {
        if (ctxtUser?.isComUser)
            navigate(route.cPolist)
        else if (ctxtUser?.userType === constants.store)
            navigate(route.aStorePoList)
        else
            navigate(route.aPolist)
    }

    function handleNewPrClick() {
        if (ctxtUser?.isComUser)
            navigate(route.cNewProdreqlist)
        else
            navigate(route.aNewProdreqlist)
    }

    if (isDasErr) {
        customAlert(dasErr);
        return <h2>Something went wrong</h2>
    }

    return (

        <ScrollBox height={"100%"} width={"100%"}>
            {(ctxtUser.userType === constants.focalPoint || ctxtUser.userType === constants.lineManager) &&
                <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} my={2}>
                    {currProjArr.length > 0 ? <CtrlCustomDropDown borderRadius={2} fontWeight={600} textAlign={"center"} boxShadow={2}
                        height={40} width={"40%"} handleDDChange={handleProjChange} ddArr={currProjArr} value={selProjId} needNone={false} /> :
                        <CtrlCustomDropDown borderRadius={2} fontWeight={600} textAlign={"center"} boxShadow={2} height={40} width={"40%"}
                            handleDDChange={handleProjChange} ddArr={currProjArr} value={"none"} needNone={false} />}
                    {(selProjId && currProjArr) && (ctxtUser.userType === constants.lineManager && <Box position={"relative"} sx={{ width: 180 }}>
                        <TextField label={"CFP Approval Limit (OMR)"} value={isNotEmpty(currProj?.amtLimit) ? NumberFormatter(currProj?.amtLimit ?? "0") : "NA"} InputProps={{ readOnly: true }} variant='outlined'
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    fontWeight: 600, fontSize: 14, color: "rgba(0, 0, 0, 1)", borderRadius: 2, boxShadow: 2,
                                    height: 40
                                }
                            }}
                            InputLabelProps={{ sx: { fontSize: 14, color: theme?.palette?.custom?.btn, fontWeight: 600 } }}
                        />
                        <IconButton onClick={handleAmtMdlOpen} sx={{ color: theme?.palette?.custom?.btn, position: "absolute", top: 0, right: -5 }}>
                            <MdEditSquare size={20} />
                        </IconButton>
                    </Box>)}

                </Stack>}
            {(ctxtUser.userType === constants.requestor || ctxtUser.userType === constants.approver) && <Stack direction={"row"} justifyContent="center" alignItems="center" sx={{ width: "100%", }}>
                <CountCard imgPath={`${raisedSVG}`} title={"Product Request Raised"} count={dashData?.raisedProdReq ?? 0} handleOnClick={handlePrClick} />
                <CountCard imgPath={`${approvedSVG}`} title={"Product Request Approved"} count={dashData?.approvedProdReq ?? 0} handleOnClick={handlePrClick} />
            </Stack>}
            {(ctxtUser.userType === constants.admin || ctxtUser.userType === constants.store) && <Stack direction={"row"} justifyContent="center" alignItems="center" sx={{ width: "100%", }}>
                <CountCard imgPath={`${cartSVG}`} title={"Order Request"} count={dashData?.totalPoCount ?? 0} handleOnClick={handlePoClick} />
                <CountCard imgPath={`${approvedSVG}`} title={"Order Request Delivered"} count={dashData?.completedPoCount ?? 0} handleOnClick={handlePoClick} />
            </Stack>}
            {(ctxtUser.userType === constants.focalPoint || ctxtUser.userType === constants.lineManager) && <Stack direction={"row"} justifyContent="center" alignItems="center" sx={{ width: "100%", }}>
                <CountCard imgPath={`${raisedSVG}`} title={"Product Request Raised"} count={dashData?.raisedProdReq ?? 0} handleOnClick={handlePrClick} />
                <CountCard imgPath={`${cartSVG}`} title={"Order Request"} count={dashData?.poCount ?? 0} handleOnClick={handlePoClick} />
            </Stack>}
            {ctxtUser.userType === constants.sourcing && <Stack direction={"row"} justifyContent="center" alignItems="center" sx={{ width: "100%", }}>
                <CountCard imgPath={`${cartSVG}`} title={"Order Request"} count={dashData?.totalPoCount ?? 0} handleOnClick={handlePoClick} />
                <CountCard imgPath={`${approvedSVG}`} title={"New Product Request"} count={dashData?.totalNewPr ?? 0} handleOnClick={handleNewPrClick} />
            </Stack>}
            <Stack direction={"row"} sx={{ width: "100%", mt: 2, mb: 1 }}>
                <Stack sx={{ width: "50%" }}>
                    <Typography style={{ marginLeft: 25, fontSize: 15, fontWeight: 400, marginTop: 8 }} >Products</Typography>
                </Stack>
                <Stack sx={{ width: "50%" }}>
                    <Button onClick={handleViewCatClick} sx={{ borderRadius: 8, backgroundColor: "rgba(0, 0, 0, 0)", marginLeft: "auto", mr: 4, width: 150, fontSize: 13, px: 1, py: 0, mt: 1 }}
                        variant="contained">{"View Catalog >"}</Button>
                </Stack>
            </Stack>
            {/* <Stack direction={"row"} justifyContent={'center'} sx={{ width: "100%", my: 2 }}> */}
            <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2}>
                <Box mb={0.5}>
                    <SearchTxtField handleOnClear={handleOnClear} variant={"outlined"} searchKeyWord={searchWord} onSearch={onSearch} onBtnClick={onSearchBtnClick}
                        placeholder={ctxtUser?.isComUser ? `Search Product By Name / AMTC ID / MAT Code / Desc / Manufacturer` : `Search Product By Name / AMTC ID / Desc / Manufacturer`} width={400} />
                </Box>
            </Stack>
            {/* </Stack> */}
            <Stack direction={"row"}
                sx={{
                    display: 'grid', gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)', md: 'repeat(4, 1fr)', lg: 'repeat(6, 1fr)', },
                    gap: 2, width: '100%', marginTop: 2, height: "80%"
                }}>
                {(dashData?.recentProds ?? []).map((i, index) => (
                    <ProductCard key={index} i={i} isComUser={ctxtUser?.isComUser} type={ctxtUser?.isComUser ? 'com' : 'amtc'} />
                ))}
            </Stack>

            {dashData?.totalProdsCount !== 0 && <Stack sx={{ alignItems: "center", mt: 1 }}>
                <Pagination count={Math.ceil(dashData?.totalProdsCount / limit) || 0} color={"primary"} page={pgNo} onChange={handlePageChange} variant="outlined" shape="rounded" />
            </Stack>}
            {currProj && <EditProjAmtLmit modalOpen={amtMdl} handleModalClose={handleAmtMdlClose} handleMdlSaveClose={handleAmtSaveMdlClose} currProj={currProj} />}
        </ScrollBox>

    )
}

export default Dashboard;




